var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FrSpinner',{directives:[{name:"show",rawName:"v-show",value:(!_vm.webAuthnCanceled),expression:"!webAuthnCanceled"}],staticClass:"mb-4",attrs:{"label":"Spinning"}}),_c('h5',[_vm._v(_vm._s(_vm.header))]),_c('p',[_vm._v(_vm._s(_vm.info))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }